import style from './style.module.scss'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  value?: string
  name?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export default function DatePicker({ label, value, name = 'datepicker', onChange, className, ...props }: Props) {
  return (
    <div className={style.datepicker + ' ' + className}>
      {label && <label htmlFor={props.id || name}>{label}</label>}
      <input id={props.id || name} type="date" value={value} {...props} onChange={onChange} />
    </div>
  )
}
